module.exports = __webpack_public_path__ + "static/img/logo4.4338acc1.png";